import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/cookies';

// Hook para rastrear visualizações de páginas automaticamente
const usePageTracking = () => {
  const location = useLocation();
  const previousPathRef = useRef(null);

  useEffect(() => {
    // Evitar tracking duplicado da mesma página
    if (previousPathRef.current === location.pathname) {
      return;
    }

    // Aguardar um pouco para garantir que a página carregou completamente
    const timer = setTimeout(() => {
      trackPageView(location.pathname);
      previousPathRef.current = location.pathname;
    }, 500);

    return () => clearTimeout(timer);
  }, [location.pathname]);
};

export default usePageTracking;
